import { render } from "./app-data-table-server.vue?vue&type=template&id=cb2a1078"
import script from "./app-data-table-server.vue?vue&type=script&setup=true&lang=js"
export * from "./app-data-table-server.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./app-data-table-server.vue?vue&type=style&index=0&id=cb2a1078&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./app-data-table-server.vue?vue&type=style&index=0&id=cb2a1078&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("cb2a1078")
  })
}

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/common/shared/components/app-data-table-server.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cb2a1078"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb2a1078', __exports__)) {
    api.reload('cb2a1078', __exports__)
  }
  
  module.hot.accept("./app-data-table-server.vue?vue&type=template&id=cb2a1078", () => {
    api.rerender('cb2a1078', render)
  })

}


export default __exports__